<template>
  <div>
    <span>{{ dateTimeUtil.formatDateTimeFromTimeStamp(data.created_at) }} <br /></span>
    <span v-if="data.platform">{{ data.platform }} {{ data.browser }}</span>
    <span v-else>{{ data.raw_user_agent }}</span>
  </div>
</template>

<script>
import dateTimeUtil from '../utils/dateTime';
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dateTimeUtil() {
      return dateTimeUtil;
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // console.log(this.data);
  },
};
</script>
